import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { Item } from "./Item8.js";
import { Divider } from "./Divider3.js";
import { Title } from "./Title.js";
import { RightIcon } from "./RightIcon.js";
import { RightText } from "./RightText.js";
function VerticalNav({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(Container, {
    role: "menu",
    ...props,
    children
  });
}
VerticalNav.Item = Item;
VerticalNav.Title = Title;
VerticalNav.RightIcon = RightIcon;
VerticalNav.RightText = RightText;
VerticalNav.Divider = Divider;
const Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1og7dln-0"
})(["margin:0 ", ";"], token.spacing5);
export {
  VerticalNav
};
//# sourceMappingURL=VerticalNav.js.map
